module.exports = __webpack_public_path__ + "img/Come.39dbade4.png";